/** Function to check if the provided data has a table in it's details and wraps it in a div with class table-responsive.
 * @param {Object} data - The data object containing the details.
 * @returns {string} - The details with tables wrapped in table-responsive divs.
 */
export const checkForTable = (data) => {
  // Remove non-breaking spaces
  let body = data?.details?.replace(/&nbsp;/g, "");

  // Split the body into parts before and after each table
  let upperParts = body?.split("<table");

  // Loop through each part and wrap it in a table-responsive div
  for (let i = 0; i < upperParts?.length - 1; i++) {
    upperParts[i] += "<div class='table-responsive'><table";
  }

  // Join the parts back together
  body = upperParts?.join("");

  // Split the body into parts before and after each closing table tag
  let lowerParts = body?.split("</table>");

  // Loop through each part and wrap it in a closing div tag
  for (let i = 0; i < lowerParts?.length - 1; i++) {
    lowerParts[i] += "</table></div>";
  }

  // Join the parts back together
  body = lowerParts?.join("");

  return body;
};

export const checkForTableBlog = (data) => {
  // Remove non-breaking spaces
  let body = data?.replace(/&nbsp;/g, "");

  // Split the body into parts before and after each table
  let upperParts = body?.split("<table");

  // Loop through each part and wrap it in a table-responsive div
  for (let i = 0; i < upperParts?.length - 1; i++) {
    upperParts[i] += "<div class='table-responsive'><table";
  }

  // Join the parts back together
  body = upperParts?.join("");

  // Split the body into parts before and after each closing table tag
  let lowerParts = body?.split("</table>");

  // Loop through each part and wrap it in a closing div tag
  for (let i = 0; i < lowerParts?.length - 1; i++) {
    lowerParts[i] += "</table></div>";
  }

  // Join the parts back together
  body = lowerParts?.join("");

  return body;
};
